/* Impulse initializes Quick View on hover; preload on first touch tap. */
(() => {
  const pending = new Map();
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.locab-quick-plus.btn--not-ready');
    if (!button) return;
    event.preventDefault();event.stopImmediatePropagation();
    const card = button.closest('.grid-product');
    const id = card?.dataset.productId, handle = card?.dataset.productHandle;
    if (!id || !handle || !window.theme?.preloadProductModal) return;
    if (!pending.has(id)) {
      const load = Promise.resolve(theme.preloadProductModal(handle,id,button));
      pending.set(id,load);load.finally(() => pending.delete(id)).catch(() => {});
    }
    try {await pending.get(id);if (button.isConnected && !button.classList.contains('btn--not-ready')) button.click();}
    catch (error) {console.warn('Quick View could not load',error);}
  },true);
})();
